import { forwardRef } from '@chakra-ui/system';
import { Box, BoxProps, Tr as CTr } from '@chakra-ui/react';
import { transparentize } from '@chakra-ui/theme-tools';

export const Tr = forwardRef(
  (
    {
      children,
      clickable,
      hasAccessory = true,
      even,
      sx,
      ...props
    }: BoxProps & {
      clickable?: boolean;
      even?: boolean;
      hasAccessory?: boolean;
    },
    ref: any
  ) => (
    <CTr
      ref={ref}
      as={Box}
      sx={{
        display: 'table-row',
        rounded: 4,
        '>div:first-of-type': {
          pl: hasAccessory ? 1 : 3,
          roundedLeft: 4,
        },
        '>div:last-of-type': {
          roundedRight: 4,
        },
        '&.even': {
          bg: transparentize('M.20', 0.36),
        },
        '&.odd': {
          bg: 'transparent',
        },
        ...(even
          ? {
              _even: {
                bg: transparentize('M.20', 0.36),
              },
            }
          : {
              _odd: {
                bg: transparentize('M.20', 0.36),
              },
            }),
        _hover: {
          cursor: clickable ? 'pointer' : 'default',
          bg: transparentize('M.20', 0.72),
          ' .options': {
            path: {
              fill: 'iconHighlighted',
            },
          },
        },
        '&.selected': {
          bg: 'surface2',
          ' div': {
            backgroundColor: transparentize('M.30', 0.36),
          },
        },
        ...sx,
      }}
      {...props}
    >
      {children}
    </CTr>
  )
);
